import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AllEconomicDataComponent } from './all-economic-data.component';

@NgModule({
    declarations: [AllEconomicDataComponent],
    imports: [CommonModule],
    exports: [AllEconomicDataComponent],
})
export class AllEconomicDataModule {}
